<template>
    <kt-panel>
        <action-bar>
            <router-link :to="'/knowledge-questions/' + cat_id + '/create'" class="btn btn-success mr-2">
                {{ $t('btn.new-question') }}
            </router-link>
        </action-bar>
        <div class="mt-2 mb-2">
            <div v-for="(question, index) in questions"
                 :key="index"
                 class="question-list ml-2 mr-2"
                 :id="'question-item-' + index"
            >
                <kt-row>
                    <kt-col lg="11" md="11" xs="12">
                        <div class="accordion accordion-toggle-plus" :id="'question-' + index">
                            <div class="card" style="overflow:inherit">
                                <div class="card-header bg-transparent" id="headingOne">
                                    <div class="card-title collapsed" data-toggle="collapse"
                                         :data-target="'#questionForm-' + index"
                                         :aria-controls="'questionForm-' + index">
                                        {{index+1 + ' - ' + question.title }}
                                    </div>
                                </div>
                                <div :id="'questionForm-'+ index" class="collapse" :aria-labelledby="'questionForm-' + index" :data-parent="'#question-' + index">
                                    <div class="card-body">
                                        <kt-row id="question">
                                            <div v-html="question.question" class="question-content text-justify"></div>
                                        </kt-row>
                                        <kt-row id="answer">
                                            <div v-html="question.answer" class="question-content text-justify"></div>
                                        </kt-row>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </kt-col>
                    <kt-col lg="1" md="1" xs="12">
                        <div class="float-right mr-2 mt-2">
                            <router-link
                                :to="'/knowledge-questions/' + question.id + '/update'"
                                :title="$t('btn.edit')"
                                class="btn btn-sm btn-clean btn-icon btn-icon-sm">
                                <i class="fa fa-edit"></i>
                            </router-link>
                            <a
                                href="#" @click.prevent="deleteQuestion(question.id)"
                                :title="$t('btn.delete')"
                                id="deleteBtn"
                                class="btn btn-sm btn-clean btn-icon btn-icon-sm">
                                <i class="fa fa-trash"></i>
                            </a>
                        </div>
                    </kt-col>
                </kt-row>
            </div>
        </div>
    </kt-panel>
</template>

<script>
import actionBar from '@/components/custom/action-bar'
import {mapGetters} from "vuex";
import $ from "jquery";
import { i18n } from '@/plugins/i18n'
import {knowledgeManagementService} from "../../../common/api.service";
import toastr from "toastr";

export default {
    components: {
        actionBar
    },
    data() {
        return {
            cat_id: this.$route.params.hashid
        }
    },
    computed: {
        ...mapGetters('KnowledgeManagement', [
            'questions'
        ]),
        toastr() {
            toastr.options = {
                closeButton: true,
                positionClass: "toast-bottom-center",
                preventDuplicates: true,
                rtl: false
            }
            return toastr
        }
    },
    methods: {
        deleteQuestion(hashid) {
            if(confirm(i18n.t('confirm.delete_question'))) {
                $('#deleteBtn').addClass('disabled');
                knowledgeManagementService.deleteQuestion(hashid)
                    .then(response => {
                        this.toastr.success(response.data.message)
                    })
                    .catch(({response}) => {
                        this.toastr.error(response.data.message)
                    })
                    .finally(() => {
                        $('#deleteBtn').removeClass('disabled');
                        this.$store.dispatch('KnowledgeManagement/fetchQuestions', this.cat_id)
                    })
            }
        },
    },
    mounted() {
        this.$store.dispatch('KnowledgeManagement/fetchQuestions', this.cat_id)
    }
}
</script>

<style>
.question-content{
    font-size: 14px;
    padding-right: 2em;
    line-height: 2em;
}
.question-list{
    border: 1px solid #dee2e6;
    border-top: none;
    margin-bottom: 0 !important;
}
#question-item-0 {
    border-top: 1px solid #dee2e6 !important;
}

</style>